import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'
import footerLogo from '../../Images/logo.jpeg'
import finance from './../../Images/finnacial footter.svg'
import car from './../../Images/car.svg'

const Footer = () => {
    return (
        <div className='navbar-color '>
            <div className='container col-md-11 col-text-center footer-logo'>
                <div className='col 10 pt-5 pb-4 '>
                    <Link to='/'><img className="website-logo " src={footerLogo} alt="" /></Link>
                </div>

                <div className="footer-item d-md-flex">
                <div className="col col-md-3">
                        <h4>Trustpilot come dynamically</h4>
                        <div className="social-icons py-4 d-flex">
                            <i className="fs-4  m-1 fab fa-facebook"></i>
                            <i className="fs-4  m-1 fab fa-twitter ms-2"></i>
                            <i className="fs-4  m-1 fab fa-instagram ms-2"></i>
                            <i className="fs-4  m-1 fab fa-linkedin-in ms-2"></i>
                        </div>
                    </div>
                    <div className="col col-md-2 mx-2 pb-5 footer-Items">
                        <h6 className='footer-head'>Company</h6>
                        <li>About us</li>
                        <li>How it works</li>
                        <li>Reviews</li>
                        <li>Articles</li>
                        <div>

                        </div>
                    </div>
                    <div className="col col-md-2  mx-2 pb-5  footer-Items">
                        <h6 className='footer-head'>Contact</h6>
                        <li className='help-center'>Help Center</li>
                        <li>Careers</li>
                        <li>Job Search</li>
                        <li>Dealers</li>
                    </div>
                    <div className="col col-md-3  mx-2 pb-5  footer-Items">
                        <h6 className='footer-head'>Terms $ Conditions</h6>
                        <li>Acceptalbe Use Policy</li>
                        <li>Privacy Policy</li>
                        <li>Terms of use</li>
                        <li>Cookies Policy</li>
                        <li>Recruitment Privacy Notice</li>
                        <li>Modern Slavery Statment</li>
                        <li>Gender Pay Gap Policy</li>
                    </div>
                    <div className="col col-md-2  me-2 pb-5  footer-Items">
                        <h6 className='footer-head'>Information</h6>
                        <li>Investors</li>
                        <li>Complaints Procedure</li>
                        <li>Complaints Data</li>
                    </div>
                </div>

                <div className='pb-5'>
                    <span className='divider'></span>
                </div>

                <div className='footer-last d-md-flex '>
                    <div className='col-1 p-4 p-md-0'>
                        <img className='finance-img' src={finance} alt="" />
                    </div>
                    <div className='col-11 ps-4'>
                        <p> &copy; 2022 Oodle Financial Services Limited</p>
                        <p>Oodle Car Finance is a trading name of Oodle Financial Services Limited which is registered in England & Wales, under Registered No. 07277272. Its Registered Office is One Callaghan Square, Cardiff, CF10 5BT.</p>
                        <p>Oodle Financial Services Limited is authorised and regulated by the Financial Conduct Authority (Reference Number 702459). Oodle Financial Services is a member of the Finance & Leasing Association and complies with its Lending Code, a copy of which we will provide on request.</p>
                    </div>
                </div>

            </div>
            <div className='last-section'>
                <img className='car-img px-2' src={car} alt="" />
            </div>
            <div>

            </div>
        </div>
    );
};

export default Footer;